import axios from 'axios';

const client = axios.create({ withCredentials: true });

export const fetchCustomers = (params) =>
    client.get('/api/v1/customers', { params });

export const fetchCustomer = (id) =>
    client.get(`/api/v1/customers/${id}`);

export const fetchCustomerOrders = (id, params) =>
    client.get(`/api/v1/customers/${id}/orders`, { params });

export const fetchCustomerUnlocks = (id, params) =>
    client.get(`/api/v1/customers/${id}/unlocks`, { params });

export const fetchCustomerCreditTransactions = (id, params) =>
    client.get(`/api/v1/customers/${id}/credit-transactions`, { params });

export const fetchCustomerCreditPurchases = (id, params) =>
    client.get(`/api/v1/customers/${id}/credit-purchases`, { params });

export const fetchCustomerProductPurchases = (id, params) =>
    client.get(`/api/v1/customers/${id}/product-purchases`, { params });

export const adjustCustomerCredits = (id, body) =>
    client.post(`/api/v1/customers/${id}/credits`, body);
